"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.syntheticProcess = exports.remove = exports.add = exports.createUserInputNeededArtifact = void 0;
const utils = __importStar(require("../dbNodes/utils"));
const helpers_1 = require("./helpers");
// The BUS reconcile approval gate. After `reconciledBusTape` computes the
// tie-out and persists the servicing-cycle row (awaiting_approval / pending),
// the pipeline must PAUSE for a human accept/reject before the certificate is
// issued. We model that pause the same way the datalake / verification flows
// do: a `userInputNeeded` node the BBPL runner refuses to execute, so the
// cascade stalls until an external portal action writes its success instance
// and re-enqueues (see the bus-servicing approval controller).
const createUserInputNeededArtifact = ({ referenceArtifact, }) => (0, helpers_1.newUserInputNeededNode)({
    referenceArtifact,
    inputType: 'busReconcileApproval',
});
exports.createUserInputNeededArtifact = createUserInputNeededArtifact;
// Before (today `reconciledBusTape` is a graph leaf; later it feeds the
// certificate-trigger node):
// +--------------------+                +-----------------------+
// |  reconciledBusTape +--------------->| WhatEver (if any)     |
// +--------------------+                +-----------------------+
// After:
// +--------------------+     +-----------------+     +-----------------------+
// |  reconciledBusTape +---->| UserInputNeeded +---->| WhatEver (if any)     |
// +--------------------+     |(busReconcile-   |     +-----------------------+
//                            |  Approval)      |
//                            +-----------------+
// Interpose a `userInputNeeded` node after each `reconciledBusTape`:
//  1. create a userInputNeeded node
//  2. wire reconciledBusTape => userInputNeeded
//  for each existing output of reconciledBusTape (none while it is a leaf):
//     3. wire userInputNeeded => whatever
//     4. drop reconciledBusTape => whatever
const add = (dbGraph) => (0, helpers_1.interposeUserInputGate)({
    dbGraph,
    anchors: utils.filterReconciledBusTapes(dbGraph),
    inputType: 'busReconcileApproval',
});
exports.add = add;
// Inverse of `add`: drop each busReconcileApproval userInputNeeded node and
// reconnect its single input (reconciledBusTape) straight to its outputs, so
// the round-trip is exact whether the gate was a leaf or interposed.
const remove = (dbGraph) => (0, helpers_1.removeUserInputGate)({
    dbGraph,
    gates: utils.filterUserInputNeededNodesByInputType(dbGraph, 'busReconcileApproval'),
    inputType: 'busReconcileApproval',
});
exports.remove = remove;
exports.syntheticProcess = {
    toDb: exports.add,
    fromDb: exports.remove,
};
//# sourceMappingURL=busReconcileApprovalUserInput.js.map